import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import Login from "./pages/Login";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Activities from "./pages/Activities";
import Tools from "./pages/Tools";
import Documents from "./pages/Documents";
import Payments from "./pages/Payments";
import Sessions from "./pages/Sessions";
import Emergencia from "./pages/Emergencia";
import Profile from "./pages/Profile";
import AdminRoute from "./components/AdminRoute";
import SuperAdminRoute from "./components/SuperAdminRoute";
import AdminLayout from "./layouts/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminActivities from "./pages/admin/AdminActivities";
import AdminStudents from "./pages/admin/AdminStudents";
import StudentDetail from "./pages/admin/StudentDetail";
import ActivityReport from "./pages/admin/ActivityReport";
import AdminConfig from "./pages/admin/AdminConfig";
import PublicLeadForm from "./pages/public/PublicLeadForm";
import PublicThankYou from "./pages/public/PublicThankYou";
import PublicPrivacyPolicy from "./pages/public/PublicPrivacyPolicy";
import { Loader2 } from "lucide-react";

export default function App() {
  const { user, loading, isAdmin, userType } = useAuth();
  const location = useLocation();

  // Rutas públicas (formulario de captación de leads). No requieren auth.
  // Se evalúan ANTES del gate de login para que cualquiera pueda acceder.
  if (location.pathname.startsWith("/l/")) {
    return (
      <Routes>
        <Route path="/l/:slug" element={<PublicLeadForm />} />
        <Route path="/l/:slug/gracias" element={<PublicThankYou />} />
        <Route path="/l/:slug/privacidad" element={<PublicPrivacyPolicy />} />
      </Routes>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 size={32} className="animate-spin text-brand" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  // Admin puro (sin registro de estudiante) -> solo panel admin
  if (isAdmin && userType !== "student") {
    return (
      <Routes>
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="alumnos" element={<AdminStudents />} />
          <Route path="alumnos/:studentId" element={<StudentDetail />} />
          <Route path="informes" element={<ActivityReport />} />
          <Route
            path="actividades"
            element={
              <SuperAdminRoute>
                <AdminActivities />
              </SuperAdminRoute>
            }
          />
          <Route
            path="configuracion"
            element={
              <SuperAdminRoute>
                <AdminConfig />
              </SuperAdminRoute>
            }
          />
        </Route>
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    );
  }

  // Usuario normal o admin que también es estudiante
  return (
    <Routes>
      {isAdmin && (
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<AdminDashboard />} />
          <Route path="alumnos" element={<AdminStudents />} />
          <Route path="alumnos/:studentId" element={<StudentDetail />} />
          <Route path="informes" element={<ActivityReport />} />
          <Route
            path="actividades"
            element={
              <SuperAdminRoute>
                <AdminActivities />
              </SuperAdminRoute>
            }
          />
          <Route
            path="configuracion"
            element={
              <SuperAdminRoute>
                <AdminConfig />
              </SuperAdminRoute>
            }
          />
        </Route>
      )}

      <Route element={<Layout />}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/actividades" element={<Activities />} />
        <Route path="/herramientas" element={<Tools />} />
        <Route path="/documentos" element={<Documents />} />
        <Route path="/pagos" element={<Payments />} />
        <Route path="/sesiones" element={<Sessions />} />
        <Route path="/emergencia" element={<Emergencia />} />
        <Route path="/perfil" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
